<template>
  <div
    class="bg-black h-screen w-full flex items-center justify-center text-white px-4"
  >
    <div class="w-full max-w-[1064px] mx-auto">
      <p
        class="poppins font-semibold text-[#F44F1A] text-[48.8px] lg:text-[70px] -tracking-widest mb-8"
      >
        GET IN TOUCH
      </p>
      <div v-for="(item, index) in dataContact" :key="index">
        <div class="poppins flex justify-between items-center border-b py-4">
          <p
            class="text-[#fff] font-semibold text-3xl lg:text-4xl -tracking-widest uppercase"
          >
            <span class="text-sm font-normal tracking-normal"
              >0{{ (index += 1) }}.</span
            >
            {{ item.name }}
          </p>
          <a :href="item.url" target="_blank">
            <div
              class="border border-white px-4 py-1.5 rounded-full cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="-rotate-45"
              >
                <path
                  fill="none"
                  stroke="#FFF"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M4.5 12h15m0 0l-5.625-6m5.625 6l-5.625 6"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
      <div class="flex justify-between items-center border-b py-4">
        <p
          class="text-[#fff] font-semibold text-3xl lg:text-4xl -tracking-widest uppercase"
        >
          <span class="text-sm font-normal tracking-normal">04.</span>
          Email
        </p>
        <div
          id="email"
          class="border border-white px-4 py-1.5 rounded-full cursor-pointer"
          @click="copyClipboard"
        >
          {{ email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const email = ref("akmalbeliuk@gmail.com");
const copied = ref(false);
const dataContact = ref([
  {
    name: "Linkedin",
    url: "https://www.linkedin.com/in/muhammad-akmal-beliuk-168068223/",
  },
  {
    name: "Github",
    url: "https://github.com/akmalbeliuk2001",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/akmal_beliuk/",
  },
]);

const copyClipboard = () => {
  const emailElement = document.getElementById("email");
  navigator.clipboard.writeText(emailElement.textContent);
  email.value = "Copied!";
  copied.value = true;
  setTimeout(() => {
    email.value = "akmalbeliuk@gmail.com";
    copied.value = false;
  }, 1000);
};
</script>
